<template>
  <div class="reservation-pay">
    <van-nav-bar title="预约挂号订单" left-arrow @click-left="$router.back()" placeholder/>
    <div class="content">
      <van-cell-group>
        <van-cell title="订单编号" :value="details.registerNo || '-'"/>
        <van-cell title="预约就诊人" :value="details.userMemberName"/>
        <van-cell title="预约电话" :value="details.userMemberMobile"/>
        <van-cell title="预约时间" :value="details.apptStartTime
      ? `${formatTime(details.apptStartTime).format(
        'YYYY年MM月DD日 HH:mm'
      )}-${formatTime(details.apptEndTime).format('HH:mm')}`
      : '-'
      " v-if="details.apptStartTime"/>
        <van-cell title="预约医生">
          <div class="doctor">
            <div class="avatar">
              <van-image :src="details.photo" fit="cover" round/>
            </div>
            <div class="text">
              <span>{{ details.doctorName }}</span>
              <span>-</span>
              <span>{{ details.clinicalTitle }}</span>
            </div>
          </div>
        </van-cell>
        <van-cell title="问诊方式" :value="askMethodTypes.findValue({value: details.askType})"/>
        <van-cell title="预约挂号费" :value="`￥${details.askServiceFee || 0}`"/>
        <van-cell title="优惠折扣">
          <div class="coupon" @click="
      $refs.couponSelectRef && $refs.couponSelectRef.onCouponShow()
      ">
            <span class="price">￥{{ coupons.couponPrice }}</span>
            <van-button type="info" color="#f4722c" size="mini">使用优惠券</van-button>
          </div>
        </van-cell>
      </van-cell-group>
<!--      <div class="auths" v-if="auths.url">-->
<!--        <div class="qrcode">-->
<!--          <div class="image">-->
<!--            <Qrcode :content="auths.url" :src.sync="auths.src" :options="{ margin: 4 }"/>-->
<!--          </div>-->
<!--          <div class="text">小程序挂号订单二维码</div>-->
<!--        </div>-->
<!--        <div class="link">-->
<!--          <van-button type="info" color="#5861f9" round @click="onQrcodeDownload(auths.src)">保存二维码</van-button>-->
<!--        </div>-->
<!--      </div>-->
      <div class="pay_type_box">
        <van-button round type="primary" @click="handleShowDialog(1)">发送微信支付链接</van-button>
        <van-button round type="info" @click="handleShowDialog(2)">发送支付宝链接</van-button>
      </div>
    </div>
    <!-- <div class="footer" v-else>
      <div class="money">
        <span>￥</span>
        <span class="num">{{
      ((details.askServiceFee || 0) - coupons.couponPrice).toFixed(2)
    }}</span>
      </div>
      <div class="operate">
        <van-button type="info" :loading="!submitable" @click="onPay">{{
      coupons.couponId || (details.askServiceFee || 0) <= 0 ? "免费挂号" : "生成付款链接及二维码" }}</van-button>
      </div>
    </div> -->

    <!-- 优惠券选择 -->
    <CouponSelect ref="couponSelectRef" v-model="coupons.couponPrice" :coupon-id.sync="coupons.couponId" :use-type="1"
                  :user-no="details.userNo" :user-member-id="details.userMemberId" :total-fee="details.askServiceFee"
                  auto-pick>
    </CouponSelect>

    <van-dialog v-model="qrcodes.show" title="支付链接码" confirmButtonColor="#1989fa"
                :before-close="onQrcodeBeforeClose"
                :showConfirmButton="false">
      <div class="qrcodes">
        <div class="content">
          <div class="image">
            <Qrcode :content="qrcodes.PaySkipUrl" :src.sync="qrcodes.url"/>
          </div>
          <div class="desc">请长按保存</div>
        </div>
        <div class="foot">
          <div class="button" @click="qrcodes.show = false">返回</div>
          <div class="button">
            <CoCopy :content="qrcodes.PaySkipUrl" class="copy">复制支付链接</CoCopy>
          </div>
          <div class="button" @click="onQrcodeBeforeClose">复制二维码</div>
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="payQrcodeInfo.show" :title="payQrcodeInfo.title"
                confirm-button-color="#1989fa">
      <div class="pay_code_box">
        <p class="title_tips">使用{{ payQrcodeInfo.type == 1 ? '微信' : '支付宝' }}扫一扫/长按识别支付</p>
        <div class="pay_qrcode" v-if="payQrcodeInfo.url">
          <div class="qrcode_img">
            <Qrcode :content="payQrcodeInfo.url" :src.sync="payQrcodeInfo.src" :options="{ margin: 4 }"/>
          </div>
        </div>
        <p class="tips_text">请长按保存</p>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import {askMethodTypes} from '@/hooks/useAsk'
import {formatTime} from "@/hooks/function";
import {fileBase64ToBlob, fileDownload} from "@/hooks/file";
import api from "@/utils/request";
import CouponSelect from "@/components/coupon/select.vue";
import CoCopy from "@/components/common/copy.vue";
import Qrcode from '@/components/qrcode/index.vue'

export default {
  components: {
    CouponSelect,
    CoCopy,
    Qrcode
  },
  data() {
    return {
      askMethodTypes,
      details: {},
      coupons: {
        couponId: null,
        couponPrice: 0,
      },
      submitable: true,
      qrcodes: {
        show: false,
        url: "",
        PaySkipUrl: ''
      },
      auths: {
        src: '',
        url: ''
      },
      payQrcodeInfo: {
        show: false,
        title: '支付链接码',
        type: 1,  //1 微信     2支付宝
        url: '',
        src: ''
      }

    };
  },
  mounted() {
    this.onDataGet();
  },
  methods: {
    formatTime,
    async onDataGet() {
      const {
        data: {askInfoDoctor},
      } = await api({
        method: "get",
        url: "/user-service/app/askinfo/getByAskNo",
        params: {
          askNo: this.$route.query.askNo,
        },
      });
      this.details = askInfoDoctor;
      console.log(this.details);
      this.auths.url = `${process.env.VUE_APP_AUTHORIZE_CONSENT}?type=register&askNo=${askInfoDoctor.askNo}&registerNo=${askInfoDoctor.registerNo}`
    },
    // 发起支付
    async onPay() {
      if (!this.submitable) return false;
      this.submitable = false;
      try {
        const {data = {}} = await api({
          method: "post",
          url: "/order-service/pay/unifiedOrderV2",
          data: {
            orderNo: this.details.registerNo,
            couponId: this.coupons.couponId,
            origin: 2,
          },
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (data.freeOrder == "1") {
          this.$toast("支付成功");
          setTimeout(() => {
            this.submitable = true;
            this.$router.back();
          }, 1000);
        } else {
          await this.onQrcodeCreate(data);
        }
      } catch (error) {
      }
      this.submitable = true;
    },
    // 支付二维码创建
    async onQrcodeCreate(data) {
      this.qrcodes.PaySkipUrl = data.PaySkipUrl
      this.qrcodes.show = true
    },
    // 复制支付二维码
    async onQrcodeBeforeClose() {
      try {
        const blob = fileBase64ToBlob(this.qrcodes.url);
        await navigator.clipboard.write([
          new ClipboardItem({
            [blob.type]: blob,
          }),
        ]);
        this.$toast.success("复制成功");
        this.qrcodes.show = false;
      } catch (error) {
        this.$toast.fail(`复制失败`);
        console.error(error);
      }
    },
    async onQrcodeDownload(url) {
      try {
        await this.$dialog.confirm({
          title: '是否确认保存?',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          closeOnClickOverlay: false
        })
        fileDownload(url, '小程序挂号订单二维码.jpg', true)
      } catch (error) {
      }
    },
    handleShowDialog(type) {
      this.payQrcodeInfo.type = type
      if (type === 1) {
        this.payQrcodeInfo.url = this.auths.url
        // this.payQrcodeInfo.src = this.auths.src
      }
      if (type === 2) {
        console.log(this.$route.query.askNo);
        this.payQrcodeInfo.url = `${window.location.origin}#/informedConsent?payType=1&askNo=${this.$route.query.askNo}&couponId=${this.coupons.couponId}&couponPrice=${this.coupons.couponPrice||0}&alipay=alipay`
        // askNo=WZ2024080705675
        // this.$router.push({path: '/informedConsent'})
      }
      this.payQrcodeInfo.show = true


    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";

:deep(.van-nav-bar) {

  .van-nav-bar__left,
  .van-icon {
    font-size: 20px;
    color: #333;
  }
}

.reservation-pay {
  height: 100vh;
  @include flex($dir: column);
  background: #ffffff;
}

.content {
  flex: 1;
  overflow-y: auto;

  :deep(.van-cell__title) {
    flex: none;
    color: #666;
  }

  :deep(.van-cell__value) {
    flex: 1;
    color: #333;
    font-weight: bold;
  }

  .doctor {
    @include flex(center, flex-end);

    .avatar {
      width: 30px;
      height: 30px;

      .van-image {
        width: 100%;
        height: 100%;
      }
    }

    .text {
      margin-left: 10px;
    }
  }

  .coupon {
    @include flex(center, flex-end);

    .price {
      color: #f4722c;
    }

    .van-button {
      font-weight: normal;
      margin-left: 15px;
    }
  }
}

.footer {
  @include flex(center, space-between);
  padding: 30px;

  .money {
    color: #f4722c;
    font-weight: bold;

    .num {
      font-size: 36px;
    }
  }

  .operate {
    .van-button {
      border-radius: 50px;
    }
  }
}

.qrcodes {
  .content {
    padding: 20px 20px 30px;
    display: flex;
    align-items: center;
    flex-direction: column;

    .desc {
      margin-top: 20px;
      font-size: 16px;
      color: #999;
    }

    .image {
      width: 150px;
      height: 150px;
    }
  }

  .foot {
    @include flex(center, space-between);
    border-top: 1px solid #ebedf0;
    height: 55px;

    .button {
      flex: 1;
      height: 100%;
      @include flex(center, center);
      font-size: 16px;
      cursor: pointer;

      &:not(:first-child) {
        border-left: 1px solid #ebedf0;
        color: $color-primary;
      }

      &:first-child {
        border-bottom-left-radius: 50px;
      }

      &:last-child {
        border-bottom-right-radius: 50px;
      }

      &:active {
        background: rgba(#f4f4f4, 0.5);
      }

      .copy {
        height: 100%;
        @include flex(center, center);
      }
    }
  }
}

.auths {
  text-align: center;
  padding: 25px;

  .qrcode {
    .image {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      background: #f4f4f4;
      padding: 8px;
    }

    .text {
      margin-top: 10px;
      font-size: 16px;
    }
  }

  .link {
    margin-top: 20px;

    .van-button {
      width: 200px;
      height: 45px;
    }
  }
}

.pay_type_box {
  display: flex;
  justify-content: space-evenly;
  margin-top: 40px;
}

.pay_code_box {
  .title_tips {
    font-size: 14px;
    color: #aeabab;
    text-align: center;
  }

  .pay_qrcode {

    .qrcode_img {
      width: 200px;
      height: 200px;
      margin: 0 auto;
      padding: 8px;
    }

  }

  .tips_text {
    font-size: 14px;
    color: #aeabab;
    text-align: center;
  }
}
</style>
